export const PAGE_PARAM = 'page';
export const REQUEST_PARAM = 'request';
export const ACCESS_GROUP_UNITS_PARAM = 'accessGroupUnits';

export const AccessUnitStatusClient = {
  Granted: 'Granted',
  Failure: 'Failure',
  Pending: 'Pending',
  Revoked: 'Revoked',
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type AccessUnitStatusClient = (typeof AccessUnitStatusClient)[keyof typeof AccessUnitStatusClient];
